<template>
  <div>
    <div class="loading">正在跳转中</div>
    <div style="visibility: hidden;" v-html="content"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.content = this.$route.params.content;
    if (!this.content) {
      this.$router.push({ name: "home" });
    } else {
      this.$nextTick(function() {
        //dom已更新
        document.forms["alipaysubmit"].submit();
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.loading {
  text-align: center;
  padding: 20px 0;
}
</style>